import { Box } from "@mui/material";
import { useAppSelector } from "../../../../Redux/hooks";
import { ConsentListStyle } from "../block.style";

import ConsentBlock from "./ConsentBlockMinimal";
import "../../../QuestionBuilder/QuestionPreview/questionpreview.scss";
import MobilePreview from "../MobilePreview/MobilePreview";

const CBPreviewConsent = () => {
  const blocks = useAppSelector((state) => state.consent.blocks);
  return (
    <>
      <Box sx={ConsentListStyle}>
        <Box
          sx={{
            width: "60%",
            bgcolor: "#FFFFFF",
            margin: "0 auto",
            p: 4,
            borderRadius: "12px",
            my: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {blocks.length > 0
            ? blocks.map((block, index) => {
                return (
                  <ConsentBlock block={block} index={index} key={block.id} />
                );
              })
            : null}
        </Box>
      </Box>
      <MobilePreview />
    </>
  );
};

export default CBPreviewConsent;
